const space = {
  s0: '0',
  s2: '0.2rem',
  s4: '0.4rem',
  s8: '0.8rem',
  s12: '1.2rem',
  s14: '1.4rem',
  s16: '1.6rem',
  s20: '2.0rem',
  s24: '2.4rem',
  s32: '3.2rem',
  s40: '4.0rem',
  s48: '4.8rem',
  s64: '6.4rem',
  s80: '8.0rem',
  s96: '9.6rem',
  s128: '12.8rem',
  s160: '16.0rem',
  s240: '24.0rem',
  s280: '28.0rem',
  s320: '32.0rem',
  s400: '40.0rem',
  s640: '64.0rem',
  s800: '80.0rem',
} as const

export default space

export type ThemeSpace = keyof typeof space
